import React from "react";

import "./App.css";
import "./reactSlick.css";
import "react-image-lightbox/style.css";

import { ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import theme from "./theme";

import { Route, RouteComponentProps, Switch } from "react-router-dom";
import "normalize.css";
import MainContainer from "./Container/MainContainer";
import HeaderContainer from "./Container/HeaderContainer";

import ArchivePageRouter from "./router/ArchivePageRouter";
import AboutPageSection from "./Container/MainContainer/AboutPageSection";
import FooterContainer from "./Container/FooterContainer";

import BoardPageRouter from "./router/BoardPageRouter";
import WebToonRouter from "./router/WebToonRouter";
import ConcertRouter from "./router/ConcertRouter";
import CitizenJoyRouter from "./router/CitizenJoyRouter";
import LaborIssueRouter from "./router/LaborIssueRouter";
import MapContainer from "./Container/MainContainer/MapContainer";
import ScheduleRouter from "./router/ScheduleRouter";

function App() {
  return (
    <ThemeProvider theme={theme}>
      {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
      <CssBaseline />
      <HeaderContainer />
      <Switch>
        <Route
          exact
          path={"/"}
          component={({ match, location, history }: RouteComponentProps) => {
            return (
              <MainContainer
                match={match}
                location={location}
                history={history}
              />
            );
          }}
        />

        <Route
          exact
          path={"/about"}
          component={({ match, location, history }: RouteComponentProps) => {
            return <AboutPageSection />;
          }}
        />

        <Route
          path={"/notice"}
          component={({ match, location, history }: RouteComponentProps) => {
            return (
              <BoardPageRouter
                match={match}
                history={history}
                location={location}
              />
            );
          }}
        />

        <Route
          path={"/archive"}
          component={({ match, location, history }: RouteComponentProps) => {
            return (
              <ArchivePageRouter
                match={match}
                location={location}
                history={history}
              />
            );
          }}
        />

        <Route
          path={"/webtoon"}
          component={({ match, location, history }: RouteComponentProps) => {
            return (
              <WebToonRouter
                match={match}
                location={location}
                history={history}
              />
            );
          }}
        />

        <Route
          path={"/concert"}
          component={({ match, location, history }: RouteComponentProps) => {
            return (
              <ConcertRouter
                match={match}
                location={location}
                history={history}
              />
            );
          }}
        />

        <Route
          path={"/citizen-joy"}
          component={({ match, location, history }: RouteComponentProps) => {
            return (
              <CitizenJoyRouter
                match={match}
                location={location}
                history={history}
              />
            );
          }}
        />

        <Route
          path={"/labor-issue"}
          component={({ match, location, history }: RouteComponentProps) => {
            return (
              <LaborIssueRouter
                match={match}
                location={location}
                history={history}
              />
            );
          }}
        />

        <Route
          path={"/map"}
          component={({ match, location, history }: RouteComponentProps) => {
            return (
              <MapContainer
                match={match}
                location={location}
                history={history}
              />
            );
          }}
        />

        <Route
          path={"/schedule"}
          component={({ match, location, history }: RouteComponentProps) => {
            return (
              <ScheduleRouter
                match={match}
                history={history}
                location={location}
              />
            );
          }}
        />
      </Switch>
      <FooterContainer />
    </ThemeProvider>
  );
}

export default App;
